import { useFormikContext } from 'formik';
import React, { useState } from 'react';
import InlineForm from '../../../common/inline/InlineForm';
import InlineSelect from '../../../common/inline/InlineSelect';
import InlineTextField from '../../../common/inline/InlineTextField';
import {
  CapaProbabilityText,
  CapaSeverityText,
  CapaSource
} from '../Capa.interface';
import { CapaDetailsCardProps } from './CapaDetailsCard';
import { useTaskEntityFields } from '../../workflow/Workflow.hooks';
import { InlineFormControl } from '../../../common/inline/InlineFormControl';
import { User } from '../../../user/User.interface';
import SingleUserSelector from '../../users/components/SingleUserSelector';

export const CapaDetailsCardContext: React.FC<CapaDetailsCardProps> = ({
  capa
}) => {
  const formikRef = useFormikContext();
  const [currentCapaOwner, setCurrentCapaOwner] = useState<number | undefined>(
    capa.capaOwner?.id
  );
  const { isFieldDisabled } = useTaskEntityFields(capa.task);

  return (
    <InlineForm>
      <InlineTextField
        name='title'
        label='Title'
        placeholder='required'
        disabled={isFieldDisabled('title')}
      />
      <InlineTextField
        name='summary'
        label='Summary'
        disabled={isFieldDisabled('summary')}
        multiline
        placeholder='required'
      />
      <InlineSelect
        name='source'
        label='Source'
        disabled={isFieldDisabled('source')}
        grid={{ xs: 6 }}
        options={Object.values(CapaSource)}
      />
      <InlineTextField
        name='sourceReference'
        label='Source Reference'
        disabled={isFieldDisabled('sourceReference')}
      />
      <InlineTextField
        name='description'
        label='Description'
        disabled={isFieldDisabled('description')}
        multiline
      />
      <InlineFormControl label='Capa Owner'>
        <SingleUserSelector
          value={currentCapaOwner}
          textFieldProps={{
            label: undefined,
            placeholder: 'Select a user to assign as the CAPA owner'
          }}
          disabled={isFieldDisabled('capaOwner')}
          onChange={(user: User | null) => {
            setCurrentCapaOwner(user?.id);
            formikRef.setFieldValue('capaOwner', user?.id, true);
            formikRef.submitForm();
          }}
        />
      </InlineFormControl>
      <InlineSelect
        name='severity'
        label='Severity'
        disabled={isFieldDisabled('severity')}
        grid={{ xs: 12, sm: 6 }}
        options={CapaSeverityText.map((text, index) => ({
          label: index + 1 + ': ' + text,
          value: index + 1
        }))}
        onChange={event => {
          formikRef
            .getFieldHelpers('risk')
            .setValue(
              +event.target.value *
                Number(formikRef.getFieldMeta('probability').value)
            );
        }}
      />
      <InlineSelect
        name='probability'
        label='Probability'
        disabled={isFieldDisabled('probability')}
        grid={{ xs: 12, sm: 6 }}
        options={CapaProbabilityText.map((text, index) => ({
          label: index + 1 + ': ' + text,
          value: index + 1
        }))}
        onChange={event => {
          formikRef
            .getFieldHelpers('risk')
            .setValue(
              +event.target.value *
                Number(formikRef.getFieldMeta('severity').value)
            );
        }}
      />
      {/* <InlineTextField
        name='risk'
        label='Risk'
        disabled={true}
        grid={{ sm: 6, md: 4 }}
      /> */}
      <InlineTextField
        name='correctiveActions'
        label='Corrective Actions'
        disabled={isFieldDisabled('correctiveActions')}
        multiline={true}
        placeholder='required'
      />
    </InlineForm>
  );
};

export default CapaDetailsCardContext;
